module.exports = __webpack_public_path__ + "img/ico_footer.a3f42459.png";